import { CEDeficiencyBase } from './ce-deficiency-base'


export class CEDeficiency extends CEDeficiencyBase {

}